import type * as maplibreglType from 'maplibre-gl';

export const DEFAULT_COLOR = '#c71585';

export const DEFAULT_CIRCLE_RADIUS = 7;
export const DEFAULT_CIRCLE_OPACITY = 0.6;
export const DEFAULT_CIRCLE_STROKE_WIDTH = 2;
export const DEFAULT_CIRCLE_STROKE_OPACITY = 1;

export const DEFAULT_FILL_OPACITY = 0.35;
export const DEFAULT_OUTLINE_WIDTH = 1;
export const DEFAULT_OUTLINE_OPACITY = 1;

export const DEFAULT_SYMBOL_ICON_SIZE = 0.5;
export const DEFAULT_SYMBOL_TEXT_SIZE = 12;
export const DEFAULT_SYMBOL_TEXT_ANCHOR = 'top';
export const DEFAULT_SYMBOL_TEXT_OFFSET = [0, 1];

export const DEFAULT_TEXT_COLOR = '#000000';
export const DEFAULT_TEXT_HALO_COLOR = '#ffffff';

export const DEFAULT_STROKE_WIDTH: maplibreglType.ExpressionSpecification = [
    "interpolate",
    ["linear"],
    ["zoom"],
    9, 1,
    12, 2,
    14, 5,
    20, 10,
]